const schema = () => ({
  type: 'object',
  required: ['type_id'],
  properties: {
    type_id: {
      title: 'نوع',
      type: 'string',
    },
    shop_id: {
      title: 'فروشگاه',
      type: 'string',
    },
    pages: {
      title: 'صفحه',
      type: 'string',
      oneOf: [
        { const: 'landing', title: 'صفحه ورود هایپرانو' },
        { const: 'shop', title: 'صفحه فروشگاه' },
        { const: 'wholesale', title: 'صفحه خرید عمده' },
        { const: 'packages', title: 'صفحه پکیج ها' },
        { const: 'discounts', title: 'صفحه تخفیف ها' },
        { const: 'about', title: 'صفحه درباره ما' },
        { const: 'contact', title: 'صفحه تماس با ما' },
        { const: 'privacy', title: 'صفحه قوانین' },
        { const: 'conditions', title: 'صفحه شرایط' },
      ],
      default: 'landing',
    },
    title: {
      type: 'string',
      title: 'عنوان',
    },
    text: {
      title: 'متن',
      type: 'string',
    },
    url: {
      title: 'لینک',
      type: 'string',
      format: 'uri',
    },
    start_time: {
      type: 'string',
      title: 'تاریخ شروع',
      format: 'date',
    },
    end_time: {
      type: 'string',
      title: 'تاریخ پایان',
      format: 'date',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
});

export default schema;
